import { createSlice } from "@reduxjs/toolkit";
import { IFreshmanConfigurationSlice, IFreshmanInactiveVersionSlice } from "../../../models/freshman/configuration";

const initialInactiveVersion: IFreshmanInactiveVersionSlice = {
  inactiveVersion : undefined
};

const inactiveVersionSlice = createSlice({
  name: "inactiveVersion",
  initialState: initialInactiveVersion,
  reducers: {
    setInactiveVersion: (state, action: { payload: any }) => {
      state.inactiveVersion = action.payload;
    },
  },
});

export const {setInactiveVersion} = inactiveVersionSlice.actions;
const inactiveVersionReducers = inactiveVersionSlice.reducer;
export type inactiveVersionState = ReturnType< typeof inactiveVersionReducers>
export default inactiveVersionReducers;